import { createSlice } from '@reduxjs/toolkit';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { PayHistoryState } from './types/PayHistoryState';
import { getEmployeesWithReportedPayroll, getPayHistory, getReportingPeriods } from './payHistoryThunks';
import { getEmployeesWithReportedPayrollOptions, getMonthOptions } from '../../common/utils';

const initialState: PayHistoryState = {
  loadingPayHistory: null,
  loadingReportingPeriods: ThunkRequestStatus.Pending,
  loadingEmployeesWithReportedPayroll: ThunkRequestStatus.Pending,
  employeesWithReportedPayrollOptions: [],
  payHistory: { reportedPayrolls: [], tooManyRecords: false },
  reportingPeriodOptions: [],
  error: '',
};

const payHistorySlice = createSlice({
  initialState,
  name: 'payHistory',
  reducers: {
    resetPayHistory() {
      return initialState;
    },
  },
  extraReducers: builder => {
    // Get pay history
    builder.addCase(getPayHistory.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingPayHistory = ThunkRequestStatus.Fulfilled;
        state.payHistory = action.payload;
      }
    });
    builder.addCase(getPayHistory.pending, state => {
      state.loadingPayHistory = ThunkRequestStatus.Pending;
    });
    builder.addCase(getPayHistory.rejected, state => {
      state.loadingPayHistory = ThunkRequestStatus.Rejected;
    });
    //Get employees with reported payroll
    builder.addCase(getEmployeesWithReportedPayroll.fulfilled, (state, action) => {
      if (action.payload) {
        state.employeesWithReportedPayrollOptions = getEmployeesWithReportedPayrollOptions(action.payload);
        state.loadingEmployeesWithReportedPayroll = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getEmployeesWithReportedPayroll.pending, state => {
      state.loadingEmployeesWithReportedPayroll = ThunkRequestStatus.Pending;
    });
    builder.addCase(getEmployeesWithReportedPayroll.rejected, state => {
      state.loadingEmployeesWithReportedPayroll = ThunkRequestStatus.Rejected;
    });
    // Get all months an employer can report salary for
    builder.addCase(getReportingPeriods.fulfilled, (state, action) => {
      if (action.payload) {
        state.reportingPeriodOptions = getMonthOptions(action.payload);
        state.loadingReportingPeriods = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getReportingPeriods.pending, state => {
      state.loadingReportingPeriods = ThunkRequestStatus.Pending;
    });
    builder.addCase(getReportingPeriods.rejected, state => {
      state.loadingReportingPeriods = ThunkRequestStatus.Rejected;
    });
  },
});
export const { resetPayHistory } = payHistorySlice.actions;
export const payHistoryReducer = payHistorySlice.reducer;
